"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTableSelectForFilter = void 0;
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var lab_1 = require("@material-ui/lab");
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var styled_components_1 = __importDefault(require("styled-components"));
var CheckboxChecked_1 = __importDefault(require("../icons/CheckboxChecked"));
var CheckboxDefault_1 = __importDefault(require("../icons/CheckboxDefault"));
var DeleteChipIcon_1 = __importDefault(require("../icons/DeleteChipIcon"));
var fieldsProps_1 = require("../utils/fieldsProps");
var checkboxProps = {
    icon: react_1.default.createElement(CheckboxDefault_1.default, null),
    checkedIcon: react_1.default.createElement(CheckboxChecked_1.default, null),
    color: 'primary',
};
var SelectCheckbox = styles_1.withTheme(styled_components_1.default(core_1.Checkbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        &.MuiCheckbox-colorPrimary {\n            padding: 0;\n            color: ", ";\n            margin-right: ", ";\n        }\n    "], ["\n        &.MuiCheckbox-colorPrimary {\n            padding: 0;\n            color: ", ";\n            margin-right: ", ";\n        }\n    "])), function (_a) {
    var theme = _a.theme;
    return theme.variables.palette.mainMiddleLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing(2) + "px";
}));
var useStyles = styles_1.createStyles(function (theme) {
    return styles_1.createStyles({
        groupLabel: {
            lineHeight: '180%',
            padding: '5px 15px',
            backgroundColor: theme.palette.background.paper,
            top: -8,
            display: '-webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
        },
        listBox: {
            boxSizing: 'border-box',
            '& ul': {
                padding: 0,
                margin: 0,
            },
        },
        groupUl: {
            padding: 0,
            '& $option': {
                paddingLeft: 24,
            },
        },
    });
});
var autoCompleteProps = {
    disableClearable: false,
    freeSolo: false,
    fullWidth: true,
};
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.groupBy = function (option) {
            var selectData = _this.props.selectData;
            var selectDataGrouped = selectData;
            return _this.getTitle(option, selectDataGrouped, true);
        };
        _this.renderOptionArrayData = function (option, _a) {
            var selected = _a.selected;
            var selectData = _this.props.selectData;
            var selectDataArray = selectData;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SelectCheckbox, __assign({}, checkboxProps, { checked: selected })),
                _this.getArrayDataTitle(option, selectDataArray)));
        };
        _this.renderOptionGroupedData = function (option, _a) {
            var selected = _a.selected;
            var selectData = _this.props.selectData;
            var selectDataGrouped = selectData;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SelectCheckbox, __assign({}, checkboxProps, { checked: selected })),
                _this.getTitle(option, selectDataGrouped, false)));
        };
        _this.getOptionLabelArrayData = function (option) {
            var selectData = _this.props.selectData;
            var selectDataArray = selectData;
            return _this.getArrayDataTitle(option, selectDataArray);
        };
        _this.getOptionLabelGroupedData = function (option) {
            var selectData = _this.props.selectData;
            var selectDataGrouped = selectData;
            return _this.getTitle(option, selectDataGrouped, false);
        };
        _this.renderInput = function (params) {
            var label = _this.props.label;
            return react_1.default.createElement(core_1.TextField, __assign({}, params, fieldsProps_1.textFieldProps, { label: label }));
        };
        return _this;
    }
    Select.prototype.render = function () {
        var _a = this.props, values = _a.values, selectData = _a.selectData, onChange = _a.onChange, classes = _a.classes;
        var isArray = this.isArray(selectData);
        var selectDataArray = selectData;
        var selectDataGrouped = selectData;
        var options = isArray ? this.idArray(selectDataArray) : this.idArrayGroupedData(selectDataGrouped);
        var groupBy = undefined;
        var renderOption = this.renderOptionArrayData;
        var getOptionLabel = this.getOptionLabelArrayData;
        if (!isArray) {
            groupBy = this.groupBy;
            renderOption = this.renderOptionGroupedData;
            getOptionLabel = this.getOptionLabelGroupedData;
        }
        var filteringValues = values.filter(function (value) { return options.includes(value); });
        if (options.length) {
            if (values.length !== filteringValues.length) {
                onChange({}, filteringValues);
            }
        }
        return (react_1.default.createElement(lab_1.Autocomplete, __assign({}, autoCompleteProps, { multiple: true, popupIcon: react_1.default.createElement(ExpandMore_1.default, null), value: values, noOptionsText: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.resultsOption", defaultMessage: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" }), ChipProps: {
                deleteIcon: react_1.default.createElement(DeleteChipIcon_1.default, null),
                size: 'small',
                style: {
                    maxWidth: 200,
                },
            }, groupBy: groupBy, disableCloseOnSelect: true, options: options, getOptionLabel: getOptionLabel, onChange: onChange, renderOption: renderOption, renderInput: this.renderInput, renderGroup: function (params) {
                return [
                    react_1.default.createElement("li", { key: params.key },
                        react_1.default.createElement(core_1.Tooltip, { title: params.group.length > 90 ? params.group : '' },
                            react_1.default.createElement(core_1.ListSubheader, { className: classes === null || classes === void 0 ? void 0 : classes.groupLabel, component: "div" }, params.group)),
                        react_1.default.createElement("ul", { className: classes === null || classes === void 0 ? void 0 : classes.groupUl }, params.children)),
                ];
            } })));
    };
    Select.prototype.isArray = function (data) {
        var array = '[object Array]';
        return Object.prototype.toString.call(data) === array;
    };
    Select.prototype.idArray = function (selectData) {
        return selectData.map(function (o) { return o.id; });
    };
    Select.prototype.idArrayGroupedData = function (selectData) {
        var idArray = [];
        Object.keys(selectData).forEach(function (groupName) {
            selectData[groupName].forEach(function (i) {
                idArray.push(i.id);
            });
        });
        return idArray;
    };
    Select.prototype.getArrayDataTitle = function (option, data) {
        var selectDataItem = data.find(function (o) { return o.id === option; });
        return selectDataItem ? selectDataItem.title : '';
    };
    Select.prototype.getTitle = function (option, data, isGroupBy) {
        var title = '';
        Object.keys(data).find(function (groupName) {
            var groupedItem = data[groupName].find(function (itemGroup) { return itemGroup.id === option; });
            if (groupedItem) {
                title = isGroupBy ? groupName : groupedItem.title;
                return true;
            }
            else {
                return false;
            }
        });
        return title;
    };
    return Select;
}(react_1.default.Component));
var TTableSelectForFilter = styles_1.withStyles(useStyles)(Select);
exports.TTableSelectForFilter = TTableSelectForFilter;
var templateObject_1;
